// extracted by mini-css-extract-plugin
export default {"dashboard":"styles_dashboard__vaXb0","container":"styles_container__UwC6l","dragContainer":"styles_dragContainer__Kj+SH","dropBox":"styles_dropBox__qQKCD"};